import { styled } from '@abyss/web/tools/styled';
import { Modal } from '@abyss/web/ui/Modal';
import { Text } from '@abyss/web/ui/Text';

export const StyledTitle = styled(Text, {
  fontFamily: '$primary !important',
  fontWeight: 600,
  fontSize: '32.43px !important',
  lineHeight: '40px',
  letterSpacing: '0px',
  textAlign: 'center',
  verticalAlign: 'middle',
  color: '#002677 !important',
});
export const StyledSubTitle = styled(Text, {
  fontFamily: '$primary !important',
  fontWeight: 500,
  fontSize: '16px !important',
  lineHeight: '20px',
  color: '#323333 !important',
});
export const StyledModal = styled(Modal, {
  '.abyss-modal-content-container': {
    width: '572px',
    zIndex: 999,
  },
});

export const StyledModelSection = styled(Modal.Section, {
  display: 'flex',
  justifyContent: 'center',
  padding: '0px 150px',
  '@media (max-width: 1024px)': {
    padding: '0px 100px',
  },
  '@media (max-width: 768px)': {
    padding: '24px',
  },
});
